<template>
  <q-card class="auth-card">
    <q-card-main>
      <h1 class="text-center auth-card__heading">{{ $t('register_heading') }}</h1>
      <p class="text-center auth-card__description">{{ $t('register_description') }}</p>

      <form id="register-form" @submit.prevent="handleRegister">
        <div class="row gutter-sm">
          <div class="col-xs-12 col-sm-6">
            <!-- First Name -->
            <q-field :error="errors.has('firstName')" :error-label="errors.first('firstName')">
              <q-input
                name="firstName"
                v-model="firstName"
                v-validate.disable="'required|min:1|max:255'"
                :float-label="$t('first_name')"
                required
                autofocus/>
            </q-field>
          </div>

          <div class="col-xs-12 col-sm-6">
            <!-- Last Name -->
            <q-field :error="errors.has('lastName')" :error-label="errors.first('lastName')">
              <q-input
                name="lastName"
                v-model="lastName"
                v-validate.disable="'required|min:1|max:255'"
                :float-label="$t('last_name')"
                required/>
            </q-field>
          </div>

          <div class="col-12">
            <!-- E-Mail -->
            <q-field :error="errors.has('email')" :error-label="errors.first('email')">
              <q-input
                name="email"
                v-model="email"
                v-validate.disable="'required|email|max:255'"
                type="email"
                :float-label="$t('email')"
                required/>
            </q-field>
          </div>

          <div class="col-12">
            <!-- Password -->
            <q-field :error="errors.has('password')" :error-label="errors.first('password')">
              <q-input
                name="password"
                v-model="password"
                v-validate.disable="'required|min:8'"
                type="password"
                :float-label="$t('password')"
                required/>
            </q-field>
          </div>

          <div class="col-12">
            <!-- Newsletter -->
            <q-field>
              <q-checkbox
                name="newsletter"
                v-model="newsletter"
                :false-value="null"
                :indeterminate-value="false"
              >
                <div class="on-right">
                  {{ $t('singup_newsletter_text') }}
                </div>
              </q-checkbox>
            </q-field>

            <!-- ToS -->
            <q-field :error="errors.has('tos')" :error-label="errors.first('tos')">
              <q-checkbox
                name="tos"
                v-model="tos"
                :false-value="null"
                :indeterminate-value="false"
                :data-vv-as="$t('tos_privacy')"
                v-validate.disable="'required'"
              >
                <i18n tag="div" class="on-right cursor-default" path="tos_acceptance">
                  <a place="tos" class="primary-link" href="#" @click.prevent="handleTosClick">
                    {{ $t('tos') }}
                  </a>

                  <a place="privacyPolicy" class="primary-link" href="#" @click.prevent="handlePrivacyPolicyClick">
                    {{ $t('privacy_policy') }}
                  </a>
                </i18n>
              </q-checkbox>
            </q-field>
          </div>
        </div>

        <div class="auth-card__footer row justify-between">
          <div class="col-md-auto col-xs-12 self-center auth-card__secondary-action">
            <router-link :to="{ name: 'login' }" class="router-link">{{ $t('goto_login') }}</router-link>
          </div>

          <div class="col-md-auto col-xs-12 self-center auth-card__primary-action" v-if="!created">
            <q-btn type="submit" color="primary">{{ $t('register') }}
            </q-btn>
          </div>
        </div>
      </form>
    </q-card-main>
  </q-card>
</template>

<script>
  import { auth, general, matomo } from 'src/config'
  import { debounce, openURL } from 'quasar'
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { UserClient } from 'src/api/Users'
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapGetters } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        tos: null,
        created: false,
        newsletter: null
      }
    },

    computed: {
      ...mapGetters(['locale'])
    },

    methods: {
      handleRegister: debounce(function () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.register()
          })
      }, 200, true),

      register () {
        // If we just submit the locale locale is not set during CI
        let language = this.locale ? this.locale : general.default_locale

        new UserClient().register(this.firstName, this.lastName, this.email, this.password, this.tos, language, this.newsletter)
          .then(response => {
            window._paq.push(['trackGoal', matomo.register_goal_id])
            this.$q.localStorage.set('token', response.data.data.token)
            this.$router.go()
          })
          .catch(error => {
            createErrorFromResponse(error)
            return false
          })
      },

      handleTosClick () {
        openURL(auth.tos_link)
      },

      handlePrivacyPolicyClick () {
        openURL(auth.privacy_policy_link)
      }
    },

    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (to.query.name) {
          const name = to.query.name.split(' ')

          vm.firstName = name.length === 1 ? '' : name.slice(0, name.length - 1).join(' ')
          vm.lastName = name[name.length - 1]
        }
        vm.email = to.query.email
      })
    },

    components: {
      CheckMark
    }
  }
</script>
